import { Routes } from '@angular/router';

import { LoginoneComponent } from './loginone/loginone.component';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ComingSoonComponent } from './coming-soon/coming-soon.component';
import { LockScreenComponent } from './lockscreen/lockscreen.component';
import { SubscribesComponent } from './subscribes/subscribes.component';
import { UnderMaintanceComponent } from './under-maintance/under-maintance.component';
import { NotFoundComponent } from './not-found/not-found.component';

import { AuthGuard } from '../auth.guard';


export const SessionRoutes: Routes = [{
  path: '',
  redirectTo: 'login',
  pathMatch: 'full',
},{
  path: '',
  children: [
    {
    path: 'login',
    component: LoginoneComponent
    }, 
    {
      path: 'forgot-password',
      component: ForgotPasswordComponent
    },
  // {
  //   path: 'register',
  //   component: RegisterComponent
  // },
  //  {
  //   path: 'coming-soon',
  //   component: ComingSoonComponent
  // }, 
  // {
  //   path: 'lockscreen',
  //   component: LockScreenComponent
  // }, 
  // {
  //   path: 'not-found',
  //   component: NotFoundComponent
  // }, 
  // {
  //   path: 'subscribes',
  //   component: SubscribesComponent
  // },
  //  {
  //   path: 'undermaintance',
  //   component: UnderMaintanceComponent
  // },
]
}];



// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/session/session.routing.ts